import React from "react";
import { Container, Card, CardBody, CardTitle, CardText } from "reactstrap";
import { useTranslation } from "react-i18next";

const HowToUsePage = () => {
  const { t } = useTranslation();
  document.title = t("common.pageTitle", { page: t("howToUse.pageTitle") });

  return (
    <div className="how-to-use">
      <div className="page-content">
        <Container fluid>
          <Card body>
            <CardBody className="pb-5">
              <CardTitle tag="h1" className="text-white text-center">
                {t("howToUse.heading")}
              </CardTitle>
              <CardText>
                Lorem ipsum dolor sit amet consectetur. Pellentesque sociis nisi
                penatibus lacus iaculis. Lorem id maecenas quisque quisque
                venenatis nunc et elit ultrices. Consectetur eget proin cursus
                nunc lorem quis. Bibendum ante neque fringilla sed elementum.
                Pellentesque dolor fermentum pellentesque morbi ac tortor amet
                enim nunc. Quis proin eget vulputate quis enim quam magna. At
                vivamus aenean ut tellus quis proin pellentesque. Rhoncus proin
                nibh lorem ut. Congue turpis dolor id fusce. Scelerisque
                ultrices dictum adipiscing ipsum neque habitasse massa. Nec sit
                ut congue nunc. Eget tortor enim sed maecenas. Ut mattis nunc
                sagittis vivamus gravida sed massa in. Penatibus blandit massa
                nascetur vitae scelerisque arcu et. Lectus risus sed euismod
                phasellus pharetra nunc pellentesque cursus imperdiet. Eu congue
                magna cursus placerat duis. Tincidunt lectus sit tristique
                lobortis posuere vulputate elementum integer ac. Sed nisi
                bibendum in amet sed elit quam commodo venenatis. Aliquam varius
                interdum aliquam est tortor ipsum. Venenatis donec elit blandit
                aenean sagittis velit dui vel. Tellus aenean volutpat
                pellentesque id. Leo pretium mi accumsan vitae sollicitudin est.
                Felis eu at venenatis ac nec sed. Facilisis sed enim sed
                egestas. Quam morbi leo at magna massa lorem eget tristique.
                Platea lacus magna senectus a aliquam blandit aliquam. Odio
                venenatis integer id cursus. Quis sapien lorem urna non vitae
                ornare fusce vivamus amet. Faucibus magna eget et diam risus
                odio. Sit volutpat nullam porta porta consequat. Purus massa
                luctus sed nibh. Sit mi eu eget viverra convallis. Elementum
                feugiat lacus urna ultrices ac sed augue. Lectus euismod
                consectetur nec eget tincidunt nam diam felis. Sagittis erat
                nibh faucibus mauris eget cursus scelerisque. Cursus etiam odio
                tortor enim porttitor enim neque ut. Pretium sit pharetra
                commodo nam nunc amet morbi sagittis turpis. Enim interdum elit
                sociis vulputate dictum ornare ipsum. Arcu turpis molestie lorem
                laoreet sit vitae et. Odio massa eu amet urna eleifend elementum
                enim posuere. In ut condimentum facilisi viverra pulvinar
                imperdiet. Sit nullam sit faucibus ante sit porttitor placerat
                magna.
              </CardText>
            </CardBody>
          </Card>
        </Container>
      </div>
    </div>
  );
};

export default HowToUsePage;
